module.exports = __webpack_public_path__ + "img/hm-guests.71aecbec.png";